import { ObjectFactory } from '@/config/objectFactory';
import { ApiRequest } from '@/types/request';
import { ApiResponse, UploadFileResponse } from '@/types/response';
import { CommonUtils } from '@/util/commonUtils';
import { MedTransGoConstants } from '@/util/constants';
import { IFileService } from '../iFileService';

export class FileService implements IFileService {

    public async uploadFile(file: FormData, baseUrl: string): Promise<ApiResponse<UploadFileResponse>> {
        const iHttpService = ObjectFactory.getHttpService();
        const apiRequest: ApiRequest = {
            baseURL: baseUrl,
            headers: {
                'Content-Type': 'multipart/form-data',
            },
            url: `${MedTransGoConstants.HTTP_URL_RESOURCE}`,
            data: file,
        };
        const response = await iHttpService.post<UploadFileResponse>(apiRequest);
        if (response.success && response.data) {
            return response;
        } else {
            CommonUtils.showError(response);
            throw new Error(JSON.stringify(response));
        }
    }

    public async deleteFile(fileId: string, baseUrl: string): Promise<ApiResponse<string>> {
        const iHttpService = ObjectFactory.getHttpService();
        const apiRequest: ApiRequest = {
            baseURL: baseUrl,
            url: `${MedTransGoConstants.HTTP_URL_RESOURCE}/${fileId}`,
            loaderEvent: {
                show: true,
            },
        };
        const response = await iHttpService.delete<string>(apiRequest);
        return response;
    }

}
